import {Alert, Breadcrumb, Button, Col, Row, Tabs} from "antd";
import {DashboardWrapper} from "../../../../../layouts/dashboard-wrapper";
import {Link, useNavigate, useSearchParams} from "react-router-dom";
import {ShareProductWidget} from "../../../../../components/products/share-product-widget";
import {useEffect, useState} from "react";
import {ErrorBoundary} from "react-error-boundary";
import {useGetStoreServiceContext} from "../../../../../service-feature/useCases/edit-service/context/get-store-service";
import {StoreServiceSalesAndInsights} from "../../../../../components/store/services/sales-and-insights";
import {EditStoreServiceCheckoutForm} from "../../../../../service-feature/useCases/edit-service/checkout-form";
import {EditStoreServiceBasicForm} from "../../../../../service-feature/useCases/edit-service/basic-form";
import {ShareStoreServiceWidget} from "../../../../../components/store/services/share-service-widget";
import {OfferingAutomations} from "../../../../../components/offering-form/automations-step";

type TabKeys = "form" | "automations" | "checkoutForm" | "insights";
export function EditStoreServicePage() {
  const {
    state: {storeServiceData, isFetchingStoreService},
  } = useGetStoreServiceContext();
  const [searchParams] = useSearchParams();
  const activeTab = searchParams.get("activeTab");
  const [defaultActiveKey, setDefaultActiveKey] = useState<TabKeys>("form");
  const navigate = useNavigate();

  useEffect(() => {
    if (activeTab) {
      if (activeTab === "checkoutForm") {
        setDefaultActiveKey(activeTab);
      }
      if (activeTab === "insights") {
        setDefaultActiveKey(activeTab);
      }
      if (activeTab === "automations") {
        setDefaultActiveKey(activeTab);
      }
    }
  }, [activeTab]);

  function handleTabClick(key: string) {
    if (key === "form") {
      setDefaultActiveKey("form");
      navigate(`${window.location.pathname}?activeTab=form`);
    }
    if (key === "automations") {
      setDefaultActiveKey("automations");
      navigate(`${window.location.pathname}?activeTab=automations`);
    }
    if (key === "checkoutForm") {
      setDefaultActiveKey("checkoutForm");
      navigate(`${window.location.pathname}?activeTab=checkoutForm`);
    }
    if (key === "insights") {
      setDefaultActiveKey("insights");
      navigate(`${window.location.pathname}?activeTab=insights`);
    }
  }

  return (
    <DashboardWrapper pageTitle={`Edit Product`}>
      <Breadcrumb>
        <Breadcrumb.Item>
          <Link to="/products">Store</Link>
        </Breadcrumb.Item>
        <Breadcrumb.Item>{storeServiceData.productService.name}</Breadcrumb.Item>
      </Breadcrumb>
      <div style={{marginTop: "1.5rem"}}>
        <Row gutter={[36, 30]}>
          <Col span={24} lg={{span: 16}}>
            <div>
              <Tabs
                defaultActiveKey={defaultActiveKey}
                activeKey={defaultActiveKey}
                onTabClick={(key) => handleTabClick(key)}
              >
                <Tabs.TabPane tab="Service info" key="form">
                  <ErrorBoundary
                    FallbackComponent={({error, resetErrorBoundary}) => (
                      <>
                        <div style={{marginTop: "1.8rem"}}>
                          <Alert
                            message="Sorry, something went wrong."
                            showIcon
                            description={error.message}
                            type="error"
                            action={
                              <Button
                                onClick={() => {
                                  resetErrorBoundary();
                                }}
                                size="small"
                                danger
                              >
                                Reset
                              </Button>
                            }
                          />
                        </div>
                      </>
                    )}
                  >
                    <EditStoreServiceBasicForm />
                  </ErrorBoundary>
                </Tabs.TabPane>
                <Tabs.TabPane tab="Automations" key="automations">
                  <ErrorBoundary
                    FallbackComponent={({error, resetErrorBoundary}) => (
                      <>
                        <div style={{marginTop: "1.8rem"}}>
                          <Alert
                            message="Sorry, something went wrong."
                            showIcon
                            description={error.message}
                            type="error"
                            action={
                              <Button
                                onClick={() => {
                                  resetErrorBoundary();
                                }}
                                size="small"
                                danger
                              >
                                Reset
                              </Button>
                            }
                          />
                        </div>
                      </>
                    )}
                  >
                    <OfferingAutomations
                      contextOfferingId={storeServiceData.productService.id}
                    />
                  </ErrorBoundary>
                </Tabs.TabPane>
                <Tabs.TabPane tab="Checkout form" key="checkoutForm">
                  <ErrorBoundary
                    FallbackComponent={({error, resetErrorBoundary}) => (
                      <>
                        <div style={{marginTop: "1.8rem"}}>
                          <Alert
                            message="Sorry, something went wrong."
                            showIcon
                            description={error.message}
                            type="error"
                            action={
                              <Button
                                onClick={() => {
                                  resetErrorBoundary();
                                }}
                                size="small"
                                danger
                              >
                                Reset
                              </Button>
                            }
                          />
                        </div>
                      </>
                    )}
                  >
                    <EditStoreServiceCheckoutForm />
                  </ErrorBoundary>
                </Tabs.TabPane>
                <Tabs.TabPane tab="Sales and insights" key="insights">
                  <ErrorBoundary
                    FallbackComponent={({error, resetErrorBoundary}) => (
                      <>
                        <div style={{marginTop: "1.8rem"}}>
                          <Alert
                            message="Sorry, something went wrong."
                            showIcon
                            description={error.message}
                            type="error"
                            action={
                              <Button
                                onClick={() => {
                                  resetErrorBoundary();
                                }}
                                size="small"
                                danger
                              >
                                Reset
                              </Button>
                            }
                          />
                        </div>
                      </>
                    )}
                  >
                    <StoreServiceSalesAndInsights />
                  </ErrorBoundary>
                </Tabs.TabPane>
              </Tabs>
            </div>
          </Col>
          <Col span={24} lg={{span: 8}}>
            <ErrorBoundary
              FallbackComponent={({error, resetErrorBoundary}) => (
                <>
                  <div style={{marginTop: "1.8rem"}}>
                    <Alert
                      message="Sorry, something went wrong."
                      showIcon
                      description={error.message}
                      type="error"
                      action={
                        <Button
                          onClick={() => {
                            resetErrorBoundary();
                          }}
                          size="small"
                          danger
                        >
                          Reset
                        </Button>
                      }
                    />
                  </div>
                </>
              )}
            >
              <ShareStoreServiceWidget
                isFetching={isFetchingStoreService}
                storeServiceData={storeServiceData}
              />
            </ErrorBoundary>
          </Col>
        </Row>
      </div>
    </DashboardWrapper>
  );
}
